import React, { FC, useState, useRef, useEffect, ChangeEvent } from "react"
import { AdminTabs } from "../Dashboard/admin/AdminTabs"
import {
  MagnifyingGlassIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  Bars3Icon,
  ChevronDownIcon,
  ArrowDownTrayIcon,
  ArrowUpTrayIcon,
} from "@heroicons/react/24/outline"
import { MexicoMarketType, PortOfEntryType } from "@/lib/types"
import * as XLSX from "xlsx"

type Props = {
  heading: string
  btn?: string
  btnClick?: () => void
  barsIcon?: boolean
  paginationBtns: boolean
  searchBar: boolean
  selectedTab?: string
  setSelectedTab?: (id: string) => void
  search?: ((form: string) => void | undefined) | undefined
  next?: () => void
  previous?: () => void
  orderNext?: (identifier: string, newPage: number) => void
  orderPrevious?: (identifier: string, newPage: number) => void
  page?: number
  input?: string
  maxPage?: number
  carrier?: boolean
  sportRates?: boolean
  carrierRates?: boolean
  transloadPartner?: boolean
  setOnboarded?: (onboarded: boolean | undefined) => void
  setCTPAT?: (CTPAT: boolean | undefined) => void
  setHazmat?: (hazmat: boolean | undefined) => void
  setTransload?: (transload: boolean | undefined) => void
  setEquipmentType?: (equipment: string) => void
  setPortOfEntryId?: (PortOfEntry: string) => void
  portOfEntryListing?: { data: PortOfEntryType[] }
  mexicoMarketList?: { data: MexicoMarketType[] }
  setType?: (type: string) => void
  setMexicoMarket?: (market: { id: string; name: string }) => void
  directRates?: boolean
  domesticStateList?: string[]
  users?: boolean
  mexicoMarket?: { id: string | undefined; name: string | undefined }
  setRole?: (role: string | undefined) => void
  marginPercentage?: boolean
  capacityType?: boolean
  capacityTypeName?: string
  setCapacityType?: (capacityType: string) => void
  capacityTypeList?: string[]
  customerContractRates?: boolean
  contractOriginList?: string[]
  contractDestinationList?: string[]
  contractOrigin?: string
  contractDestination?: string
  setContractOrigin?: (origin: string) => void
  setContractDestination?: (destination: string) => void
  holidayModifer?: boolean
  setHolidayName?: (name: string) => void
  smallTruckRates?: boolean
  groupName?: string
  setGroupName?: (name: string) => void
  groupNameList?: string[]
  originMarketList?: string[]
  destinationMarketList?: string[]
  domesticState?: string
  originMarket?: string
  destinationMarket?: string
  setDomesticState?: (state: string) => void
  setOriginMarket?: (market: string) => void
  setDestinationMarket?: (market: string) => void
  setActive?: (status: boolean | undefined) => void
  searchPage?: boolean
  quotepage?: number
  maxPageRecentQuotes?: number
  handleGenerateCSV?: (csv: { csv: boolean; filters: any }) => void
  handleUploadCSV?: (form: any) => void
  filters?: any
}

const mexicoTabs = [

  {
    identifier: "port-of-entry",
    name: "Port Of Entry",
    role: ["ADMIN"],
  },

  {
    identifier: "transload-partner?input=",
    name: "MX Transload Partners",
    role: ["ADMIN"],
  },

  {
    identifier: "carrier-rates?input=",
    name: "MX Carriers (Mexico Side)",
    role: ["ADMIN"],
  },
  {
    identifier: "direct-rates",
    name: "CB (ST-ST) Rate Modifier",
    role: ["ADMIN"],
  },
  {
    identifier: "spot-rate",
    name: "CB Bronco Spot Rates",
    role: ["ADMIN"],
  },
  {
    identifier: "spot-rates-modifier",
    name: "MX Spot Rate Modifier",
    role: ["ADMIN"],
  },
  {
    identifier: "search-page?input=",
    name: "Search Page",
    role: ["ADMIN"],
  },
  {
    identifier: "mexico-market",
    name: "Mexico Market",
    role: ["ADMIN"],
  },
  
  // {
  //   identifier: "customer-contract-rates?input=",
  //   name: "Customer Contract Rates",
  //   role: ["ADMIN"],
  // },
  {
    identifier: "carrier",
    name: "MX Carrier Network",
    role: ["ADMIN"],
  },
]
const domesticRaterTab = [
  {
    identifier: "daily-mileage",
    name: "Daily Mileage",
    role: ["ADMIN"],
  },
  {
    identifier: "margin-percentage",
    name: "Margin Percentage",
    role: ["ADMIN"],
  },
  {
    identifier: "holiday-modifier?input=",
    name: "Holiday Modifier",
    role: ["ADMIN"],
  },
  {
    identifier: "mci-table",
    name: "MCI Table",
    role: ["ADMIN"],
  },
  {
    identifier: "rate-engine-weight",
    name: "Rate Engine Weight",
    role: ["ADMIN"],
  },
  {
    identifier: "small-truck-rates",
    name: "Small Truck Rates",
    role: ["ADMIN"],
  },
  {
    identifier: "weekend-modifier",
    name: "Weekend Modifier",
    role: ["ADMIN"],
  },

  {
    identifier: "lead-time-modifier",
    name: "Lead Time Modifier",
    role: ["ADMIN"],
  },
  {
    identifier: "same-day-modifier",
    name: "Same Day Modifier",
    role: ["ADMIN"],
  },
]
const adminTab = [
  {
    identifier: "organization-credentials",
    name: "Organization Credentials",
    role: ["ADMIN"],
  },
  {
    identifier: "update-maps-data",
    name: "Update Maps Data",
    role: ["ADMIN"],
  },
{
    identifier: "customer-contract-rates?input=",
    name: "Customer Contract Rates",
    role: ["ADMIN"],
  },
  {
    identifier: "users?pageNum=1&input=",
    name: "Users",
    role: ["ADMIN"],
  },
  {
    identifier: "capacity-type",
    name: "Capacity Type",
    role: ["ADMIN"],
  },
]
export const Tab: FC<Props> = (props) => {
  const dropdownRef = useRef<any>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [clickCount, setClickCount] = useState(0)
  const mexicodropdownRef = useRef<any>(null)
  const [isOpenMexico, setIsMexicoOpen] = useState(false)
  const [clickMexicoCount, setClickMexicoCount] = useState(0)
  const domesticdropdownRef = useRef<any>(null)
  const [isOpenDomestic, setIsDomesticOpen] = useState(false)
  const [clickDomesticCount, setClickDomesticCount] = useState(0)
  const origindropdownRef = useRef<any>(null)
  const [isOpenOrigin, setIsOriginOpen] = useState(false)
  const [clickOriginCount, setClickOriginCount] = useState(0)
  const destinationdropdownRef = useRef<any>(null)
  const [isOpenDestination, setIsDestinationOpen] = useState(false)
  const [clickDestinationCount, setClickDestinationCount] = useState(0)
  const [errorMessage, setErrorMessage] = useState("")
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [fileName, setFileName] = useState("")
  const [data, setData] = useState([])
  const [inputKey, setInputKey] = useState(Date.now())

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [dropdownRef, isOpen])

  const toggleDropdown = () => {
    setClickCount((prevClickCount) => prevClickCount + 1)
    setIsOpen(clickCount % 2 === 0)
  }
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        mexicodropdownRef.current &&
        !mexicodropdownRef.current.contains(event.target)
      ) {
        setIsMexicoOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [mexicodropdownRef, isOpenMexico])

  const mexicotoggleDropdown = () => {
    setClickMexicoCount((prevClickCount) => prevClickCount + 1)
    setIsMexicoOpen(clickMexicoCount % 2 === 0)
  }

  useEffect(() => {
    if (props.mexicoMarket != undefined) {
      setIsMexicoOpen(false)
    }
  }, [props.mexicoMarket])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        domesticdropdownRef.current &&
        !domesticdropdownRef.current.contains(event.target)
      ) {
        setIsDomesticOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [domesticdropdownRef, isOpenDomestic])

  const domestictoggleDropdown = () => {
    setClickDomesticCount((prevClickCount) => prevClickCount + 1)
    setIsDomesticOpen(clickDomesticCount % 2 === 0)
  }

  useEffect(() => {
    if (
      props.domesticState != undefined ||
      props.capacityTypeName != undefined ||
      props.groupName != undefined
    ) {
      setIsDomesticOpen(false)
    }
  }, [props.domesticState, props.capacityTypeName, props.groupName])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        origindropdownRef.current &&
        !origindropdownRef.current.contains(event.target)
      ) {
        setIsOriginOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [origindropdownRef, isOpenOrigin])

  useEffect(() => {
    if (data.length > 0) {
      const uploadDeliveryData = {
        data: data,
      }
      props.handleUploadCSV?.(uploadDeliveryData)
      setFileName("")
    }
  }, [])

  const originToggleDropdown = () => {
    setClickOriginCount((prevClickCount) => prevClickCount + 1)
    setIsOriginOpen(clickOriginCount % 2 === 0)
  }

  useEffect(() => {
    if (props.originMarket != undefined || props.contractOrigin != undefined) {
      setIsOriginOpen(false)
    }
  }, [props.originMarket, props.contractOrigin])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        destinationdropdownRef.current &&
        !destinationdropdownRef.current.contains(event.target)
      ) {
        setIsDestinationOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [destinationdropdownRef, isOpenDestination])

  const destinationToggleDropdown = () => {
    setClickDestinationCount((prevClickCount) => prevClickCount + 1)
    setIsDestinationOpen(clickDestinationCount % 2 === 0)
  }
  useEffect(() => {
    if (
      props.destinationMarket != undefined ||
      props.contractDestination != undefined
    ) {
      setIsDestinationOpen(false)
    }
  }, [props.destinationMarket, props.contractDestination])

  const handleNext = (identifier: string) => {
    if (identifier === "order") {
      const newPage = (props.page as number) + 1
      props.orderNext?.(identifier, newPage)
    } else {
      const newQuotePage = (props.quotepage as number) + 1
      props.orderNext?.(identifier, newQuotePage)
    }
  }

  const handlePrevious = (identifier: string) => {
    if (identifier === "order") {
      const newPage = (props.page as number) - 1
      props.orderPrevious?.(identifier, newPage)
    } else {
      const newQuotePage = (props.quotepage as number) - 1
      props.orderPrevious?.(identifier, newQuotePage)
    }
  }

  const handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    const validExtensions = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ]
    if (!validExtensions.includes(file.type)) {
      setErrorMessage("Only .xlsx and .xls files are allowed.")
      setInputKey(Date.now()) // Reset input after invalid file
      return
    }

    setFileName(file.name)
    setErrorMessage("")

    const reader = new FileReader()

    reader.onload = (e: any) => {
      const binaryStr = e.target.result
      const workbook = XLSX.read(binaryStr, { type: "binary" })

      const sheetName = workbook.SheetNames[0]
      const sheet = workbook.Sheets[sheetName]

      const jsonData = XLSX.utils.sheet_to_json(sheet)
      const isEmptyOrInvalid = jsonData.some((item: any) =>
        Object.keys(item).every((key) => key.startsWith("__EMPTY")),
      )

      if (isEmptyOrInvalid) {
        setErrorMessage("Invalid File Data")
        setInputKey(Date.now())
        return
      }

      const filteredData = jsonData.filter((item: any) =>
        Object.values(item).every(
          (value) => value !== null && value !== undefined && value !== "",
        ),
      )

      setData(filteredData as any)
      uploadCSVData(filteredData)
    }

    reader.readAsBinaryString(file)
    setInputKey(Date.now())
  }
  const uploadCSVData = (filteredData: any) => {
    const uploadDeliveryData = { data: filteredData }
    props.handleUploadCSV?.(uploadDeliveryData)
  }

  return (
    <div
      className={
        (props.directRates || props.carrierRates || props.sportRates
          ? "flex flex-col"
          : props.customerContractRates ||
            props.transloadPartner ||
            props.smallTruckRates
            ? "xl:flex-row flex flex-col"
            : props.carrier || props.marginPercentage
              ? "lg:flex-row flex flex-col"
              : props.capacityType ||
                props.holidayModifer ||
                props.searchPage ||
                props.users ||
                props.selectedTab
                ? "md:flex-row flex flex-col"
                : "flex") +
        " md:px-3 px-2 dark:bg-secondary-15 justify-between gap-2 pt-3 pb-4"
      }
    >
      <div className="flex justify-start gap-4 z-[1] relative whitespace-nowrap">
        {props.barsIcon == true && (
          <Bars3Icon
            className="md:w-10 w-9 md:h-10 h-9 cursor-pointer text-primary-11"
            onClick={toggleDropdown}
          />
        )}
        <div>
          <h1 className="md:text-2xl text-lg dark:text-primary-10 text-light-2">
            {props.heading}
          </h1>
          <div className="md:h-1 h-0.5 w-1/2 bg-primary-8 mt-1 rounded-full"></div>
        </div>
        {isOpen && (
          <div ref={dropdownRef} className="grid absolute left-0 top-10 md:grid-cols-3 grid-cols-2 items-start gap-x-2 rounded-lg md:p-2 p-1 outline-none md:w-104 w-80 h-auto dark:bg-primary-1 bg-white text-primary-11 text-sm border-2 dark:border-secondary-11">
            <div>
              <h2 className="px-1.5 font-semibold text-lg">Mexico Rater</h2>
              <AdminTabs
                tabs={mexicoTabs.sort((a, b) => a.name.localeCompare(b.name))}
                selectedTab={props.selectedTab as string}
                selectTab={props.setSelectedTab as (id: string) => void}
              />
            </div>
            <div>
              <h2 className="px-1.5 font-semibold text-lg">Domestic Rater</h2>
              <AdminTabs
                tabs={domesticRaterTab.sort((a, b) => a.name.localeCompare(b.name))}
                selectedTab={props.selectedTab as string}
                selectTab={props.setSelectedTab as (id: string) => void}
              />
            </div>
            <div>
              <h2 className="px-1.5 font-semibold text-lg">Admin</h2>
              <AdminTabs
                tabs={adminTab.sort((a, b) => a.name.localeCompare(b.name))}
                selectedTab={props.selectedTab as string}
                selectTab={props.setSelectedTab as (id: string) => void}
              />
            </div>

          </div>
        )}
      </div>
      <div className="md:flex-row flex flex-col gap-2 justify-end">
        {props.paginationBtns == true && (
          <div className="flex gap-x-1 items-center dark:text-primary-10 text-light-2">
            <button
              className={
                ((props.page as number) === 1
                  ? true +
                  " dark:text-primary-10/10 text-light-2 hover:bg-transparent "
                  : false) + " hover:bg-primary-10/10 p-2 rounded-full"
              }
              disabled={
                (props.page as number) < (props.maxPage as number)
                  ? true
                  : false
              }
              onClick={props.previous}
              type="button"
            >
              <ChevronLeftIcon
                className={
                  ((props.page as number) === 1
                    ? true + " cursor-default dark:text-light-2 "
                    : false) + " w-4 h-4 cursor-pointer"
                }
              />
            </button>
            <p>{props.page}</p>
            <button
              className={
                ((props.page as number) > (props.maxPage as number) - 1
                  ? true +
                  " dark:text-primary-10/10 text-light-2 hover:bg-transparent"
                  : false) + " hover:bg-primary-10/10 p-2 rounded-full"
              }
              disabled={
                (props.page as number) > (props.maxPage as number) - 1
                  ? true
                  : false
              }
              onClick={props.next}
              type="button"
            >
              <ChevronRightIcon
                className={
                  ((props.page as number) > (props.maxPage as number) - 1
                    ? true + " cursor-default"
                    : false) + " w-4 h-4 cursor-pointer"
                }
              />
            </button>
          </div>
        )}
        {props.selectedTab == "quotes" ? (
          <div className="flex gap-x-1 items-center dark:text-primary-10 text-light-2">
            <button
              className={
                (props.quotepage as number) === 1
                  ? "text-primary-10/10 hover:bg-transparent cursor-default p-2 rounded-full"
                  : "hover:bg-primary-10/10 p-2 rounded-full"
              }
              disabled={(props.quotepage as number) === 1}
              onClick={() => handlePrevious("quote")}
              type="button"
            >
              <ChevronLeftIcon
                className={
                  (props.quotepage as number) === 1
                    ? "w-4 h-4 cursor-default text-gray-400 dark:text-gray-600"
                    : "w-4 h-4 cursor-pointer"
                }
              />
            </button>
            <p>{props.quotepage}</p>
            <button
              className={
                (props.quotepage as number) >=
                  (props.maxPageRecentQuotes as number)
                  ? "dark:text-primary-10/10 hover:bg-transparent cursor-default p-2 rounded-full"
                  : "hover:bg-primary-10/10 p-2 rounded-full"
              }
              disabled={
                (props.quotepage as number) >=
                (props.maxPageRecentQuotes as number)
              }
              onClick={() => handleNext("quote")}
              type="button"
            >
              <ChevronRightIcon
                className={
                  (props.quotepage as number) >=
                    (props.maxPageRecentQuotes as number) &&
                    (props.page as number) >= (props.page as number)
                    ? "w-4 h-4 cursor-default"
                    : "w-4 h-4 cursor-pointer"
                }
              />
            </button>
          </div>
        ) : props.selectedTab == "tendered" ? (
          <div className="flex gap-x-1 items-center dark:text-primary-10 text-light-2">
            <button
              className={
                (props.page as number) === 1
                  ? "dark:text-primary-10/10 text-light-2 hover:bg-transparent cursor-default p-2 rounded-full"
                  : "hover:bg-primary-10/10 p-2 rounded-full"
              }
              disabled={(props.page as number) === 1}
              onClick={() => handlePrevious("order")}
              type="button"
            >
              <ChevronLeftIcon
                className={
                  (props.page as number) === 1
                    ? "w-4 h-4 cursor-default"
                    : "w-4 h-4 cursor-pointer"
                }
              />
            </button>
            <p>{props.page}</p>
            <button
              className={
                (props.page as number) >= (props.maxPage as number)
                  ? "dark:text-primary-10/10 text-light-2 hover:bg-transparent cursor-default p-2 rounded-full"
                  : "hover:bg-primary-10/10 p-2 rounded-full"
              }
              disabled={(props.page as number) >= (props.maxPage as number)}
              onClick={() => handleNext("order")}
              type="button"
            >
              <ChevronRightIcon
                className={
                  (props.page as number) >= (props.maxPage as number)
                    ? "w-4 h-4 cursor-default"
                    : "w-4 h-4 cursor-pointer"
                }
              />
            </button>
          </div>
        ) : null}

        <div className="">
          {props.carrier && (
            <div className="grid xl:grid-cols-4 grid-cols-2 gap-2 h-full">
              <select
                className="h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) =>
                  props.setOnboarded?.(
                    e.target.value == "true"
                      ? true
                      : e.target.value == ""
                        ? undefined
                        : false,
                  )
                }
              >
                <option value="" hidden>
                  Select Onboarded
                </option>
                <option value="" disabled>
                  Select Onboarded
                </option>
                <option value="">Any</option>
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
              <select
                className="h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) =>
                  props.setCTPAT?.(
                    e.target.value == "true"
                      ? true
                      : e.target.value == ""
                        ? undefined
                        : false,
                  )
                }
              >
                <option value="" hidden>
                  Select CTPAT
                </option>
                <option value="" disabled>
                  Select CTPAT
                </option>
                <option value="">Any</option>
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
              <select
                className="h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) =>
                  props.setHazmat?.(
                    e.target.value == "true"
                      ? true
                      : e.target.value == ""
                        ? undefined
                        : false,
                  )
                }
              >
                <option value="" hidden>
                  Select Hazmat
                </option>
                <option value="" disabled>
                  Select Hazmat
                </option>
                <option value="">Any</option>
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
              <select
                className="h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) =>
                  props.setTransload?.(
                    e.target.value == "true"
                      ? true
                      : e.target.value == ""
                        ? undefined
                        : false,
                  )
                }
              >
                <option value="" hidden>
                  Select Transload
                </option>
                <option value="" disabled>
                  Select Transload
                </option>
                <option value="">Any</option>
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </div>
          )}
          {props.transloadPartner && (
            <div className="grid grid-cols-2 gap-2 h-full">
              <select
                className="h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setEquipmentType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Equipment Type
                </option>
                <option value="" disabled>
                  Select Equipment Type
                </option>
                <option value="">Any</option>
                <option value="DRY_VAN">Dry Van</option>
                <option value="FLATBED">Flatbed</option>
              </select>
              <select
                className="h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setPortOfEntryId?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Port Of Entry
                </option>
                <option value="" disabled>
                  Select Port Of Entry
                </option>
                <option value="">Any</option>
                {props.portOfEntryListing?.data.map((e, i) => (
                  <option key={i} value={e.id}>
                    {e.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          {props.carrierRates && (
            <div className="grid xl:grid-cols-5 grid-cols-3 gap-2 h-full">
              <div
                className="flex gap-1 items-center border-2 dark:text-primary-10 text-light-2 text-xs dark:border-secondary-11 rounded-md px-3 py-1 dark:bg-secondary-15 bg-white cursor-pointer h-full w-auto whitespace-nowrap"
                onClick={() =>
                  props.handleGenerateCSV?.({
                    csv: true,
                    filters: props.filters,
                  })
                }
              >
                <ArrowDownTrayIcon className="w-4 h-4 dark:text-primary-3 " />
                <span>Download</span>
              </div>
              <div>
                <label
                  htmlFor="fileInput"
                  className="flex gap-1 items-center border-2 bg-white dark:text-primary-10 text-xs text-light-2 dark:border-secondary-11 rounded-md px-3 py-1 dark:bg-secondary-15 cursor-pointer h-full w-auto whitespace-nowrap"
                >
                  <ArrowUpTrayIcon className="w-4 h-4 dark:text-primary-3 cursor-pointer" />
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {fileName ? fileName : "Choose .xlsx or .xls file"}
                  </span>
                </label>

                <input
                  className="hidden"
                  id="fileInput"
                  type="file"
                  accept=".xlsx, .xls"
                  key={inputKey}
                  onChange={handleFileUpload}
                />
              </div>

              <select
                className="h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Type
                </option>
                <option value="" disabled>
                  Select Type
                </option>
                <option value="">Any</option>
                <option value="Northbound">Northbound</option>
                <option value="Southbound">Southbound</option>
              </select>
              <div className="xl:hidden block"></div>
              <select
                className="h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setEquipmentType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Equipment
                </option>
                <option value="" disabled>
                  Select Equipment
                </option>
                <option value="">Any</option>
                <option value="DRY_VAN">Dry Van</option>
                <option value="FLATBED">Flatbed</option>
              </select>
              <div className="relative xl:w-44 w-full">
                <div
                  className="h-full flex justify-between items-center text-light-2 dark:bg-secondary-15 bg-white p-2 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none cursor-pointer"
                  onClick={mexicotoggleDropdown}
                >
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {props.mexicoMarket?.name && props.mexicoMarket.name !== ""
                      ? props.mexicoMarket.name
                      : props.mexicoMarket?.id === undefined
                        ? "Select Mexico Market"
                        : "Any"}
                  </span>
                  <ChevronDownIcon className="w-3 h-3" />
                </div>
                {isOpenMexico && (
                  <div
                    className="w-full z-10 max-h-56 dark:bg-primary-1 text-light-2 bg-white dark:text-primary-10 text-xs border-2 dark:border-secondary-11 absolute left-0 top-10  items-start rounded-lg p-2 outline-none divide-y dark:divide-zinc-800  overflow-auto"
                    ref={mexicodropdownRef}
                  >
                    <div
                      className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap p-2 cursor-default dark:text-primary-20"
                      aria-disabled
                    >
                      Select Mexico Market
                    </div>
                    <div
                      className={
                        (props.mexicoMarket?.name == ""
                          ? "dark:bg-white/5 text-primary-11"
                          : "dark:text-primary-10") +
                        " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                      }
                      onClick={() =>
                        props.setMexicoMarket?.({ id: "", name: "" })
                      }
                    >
                      Any
                    </div>
                    {props.mexicoMarketList?.data.map((e, i) => (
                      <div
                        key={i}
                        className={
                          (props.mexicoMarket?.id == e.id
                            ? "dark:bg-white/5 text-primary-11"
                            : "dark:text-primary-10") +
                          " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                        }
                        onClick={() =>
                          props.setMexicoMarket?.({
                            id: e.id,
                            name: e.name,
                          })
                        }
                      >
                        {e.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
          {props.directRates && (
            <div className="grid xl:grid-cols-6 lg:grid-cols-6 grid-cols-3 gap-2 h-full">
              <div
                className="flex gap-1 items-center border-2 dark:text-primary-10 text-xs text-light-2 bg-white dark:border-secondary-11 rounded-md px-3 py-1 dark:bg-secondary-15 cursor-pointer h-full w-auto whitespace-nowrap"
                onClick={() =>
                  props.handleGenerateCSV?.({
                    csv: true,
                    filters: props.filters,
                  })
                }
              >
                <ArrowDownTrayIcon className="w-4 h-4 dark:text-primary-3 " />
                <span>Download</span>
              </div>
              <div>
                <label
                  htmlFor="fileInput"
                  className="flex gap-1 items-center border-2 dark:text-primary-10 text-xs dark:border-secondary-11 rounded-md px-3 py-1 dark:bg-secondary-15 bg-white text-primary-1 cursor-pointer h-full w-auto whitespace-nowrap"
                >
                  <ArrowUpTrayIcon className="w-4 h-4 dark:text-primary-3 cursor-pointer" />
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {fileName ? fileName : "Choose .xlsx or .xls file"}
                  </span>
                </label>
                <input
                  className="hidden"
                  id="fileInput"
                  type="file"
                  accept=".xlsx, .xls"
                  key={inputKey}
                  onChange={handleFileUpload}
                />
              </div>
              <select
                className="w-full dark:bg-secondary-15  bg-white p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 text-light-2 outline-none"
                onChange={(e) => props.setType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Type
                </option>
                <option value="" disabled>
                  Select Type
                </option>
                <option value="">Any</option>
                <option value="Northbound">Northbound</option>
                <option value="Southbound">Southbound</option>
              </select>
              <div className="relative">
                <div
                  className="h-full flex justify-between items-center dark:bg-secondary-15 bg-white text-light-2 p-2 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none cursor-pointer"
                  onClick={mexicotoggleDropdown}
                >
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {props.mexicoMarket?.name && props.mexicoMarket.name !== ""
                      ? props.mexicoMarket.name
                      : props.mexicoMarket?.id === undefined
                        ? "Select Mexico Market"
                        : "Any"}
                  </span>
                  <ChevronDownIcon className="w-3 h-3" />
                </div>
                {isOpenMexico && (
                  <div
                    className="w-full z-10 max-h-56 dark:bg-primary-1 text-light-2 bg-white dark:text-primary-10 text-xs border-2 dark:border-secondary-11 absolute left-0 top-10  items-start rounded-lg p-2 outline-none divide-y dark:divide-zinc-800  overflow-auto"
                    ref={mexicodropdownRef}
                  >
                    <div
                      className="p-2 cursor-default text-primary-20"
                      aria-disabled
                    >
                      Select Mexico Market
                    </div>
                    <div
                      className={
                        (props.mexicoMarket?.name == ""
                          ? "dark:bg-white/5 text-primary-11"
                          : "dark:text-primary-10 ") +
                        " p-2 cursor-default hover:bg-white/5 dark:text-primary-10 "
                      }
                      onClick={() =>
                        props.setMexicoMarket?.({ id: "", name: "" })
                      }
                    >
                      Any
                    </div>
                    {props.mexicoMarketList?.data.map((e, i) => (
                      <div
                        key={i}
                        className={
                          (props.mexicoMarket?.id == e.id
                            ? "dark:bg-white/5 text-primary-11"
                            : "dark:text-primary-10 ") +
                          " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                        }
                        onClick={() =>
                          props.setMexicoMarket?.({
                            id: e.id,
                            name: e.name,
                          })
                        }
                      >
                        {e.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <select
                className="w-full dark:bg-secondary-15  bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setPortOfEntryId?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Port Of Entry
                </option>
                <option value="" disabled>
                  Select Port Of Entry
                </option>
                <option value="">Any</option>
                {props.portOfEntryListing?.data.map((e, i) => (
                  <option key={i} value={e.id}>
                    {e.name}
                  </option>
                ))}
              </select>
              <div className="relative">
                <div
                  className="h-full flex justify-between items-center dark:bg-secondary-15 bg-white p-2 text-xs border-2 text-light-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none cursor-pointer"
                  onClick={domestictoggleDropdown}
                >
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {props.domesticState
                      ? props.domesticState
                      : props.domesticState == ""
                        ? "Any"
                        : "Select Domestic State"}
                  </span>
                  <ChevronDownIcon className="w-3 h-3" />
                </div>
                {isOpenDomestic && (
                  <div
                    className="w-full z-10 max-h-56 dark:bg-primary-1 bg-white dark:text-primary-10 text-light-2 text-xs border-2 dark:border-secondary-11 absolute left-0 top-10  items-start rounded-lg p-2 outline-none divide-y dark:divide-zinc-800  overflow-auto"
                    ref={domesticdropdownRef}
                  >
                    <div
                      className="p-2 cursor-default text-primary-20"
                      aria-disabled
                    >
                      Select Domestic State
                    </div>
                    <div
                      className={
                        (props.domesticState == ""
                          ? "dark:bg-white/5 text-primary-11"
                          : "dark:text-primary-10") +
                        " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                      }
                      onClick={() => props.setDomesticState?.("")}
                    >
                      Any
                    </div>
                    {props.domesticStateList?.sort().map((e, i) => (
                      <div
                        key={i}
                        className={
                          (props.domesticState == e
                            ? "dark:bg-white/5 text-primary-11"
                            : "dark:text-primary-10") +
                          " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                        }
                        onClick={() => props.setDomesticState?.(e)}
                      >
                        {e}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
          {props.sportRates && (
            <div className="grid xl:grid-cols-7 lg:grid-cols-7 grid-cols-3 gap-2 h-full">
              <div
                className="flex gap-1 items-center border-2 dark:text-primary-10 text-xs bg-white text-light-2 dark:border-secondary-11 rounded-md px-3 py-1 dark:bg-secondary-15 cursor-pointer h-full w-auto whitespace-nowrap"
                onClick={() =>
                  props.handleGenerateCSV?.({
                    csv: true,
                    filters: props.filters,
                  })
                }
              >
                <ArrowDownTrayIcon className="w-4 h-4 dark:text-primary-3 " />
                <span>Download</span>
              </div>
              <div>
                <label
                  htmlFor="fileInput"
                  className="flex gap-1 items-center border-2 dark:text-primary-10 text-light-2 text-xs bg-white dark:border-secondary-11 rounded-md px-3 py-1 dark:bg-secondary-15 cursor-pointer h-full w-auto whitespace-nowrap"
                >
                  <ArrowUpTrayIcon className="w-4 h-4 dark:text-primary-3 cursor-pointer" />
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {fileName ? fileName : "Choose .xlsx or .xls file"}
                  </span>
                </label>
                <input
                  className="hidden"
                  id="fileInput"
                  type="file"
                  accept=".xlsx, .xls"
                  key={inputKey}
                  onChange={handleFileUpload}
                />
              </div>
              <select
                className="w-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Type
                </option>
                <option value="" disabled>
                  Select Type
                </option>
                <option value="">Any</option>
                <option value="Northbound">Northbound</option>
                <option value="Southbound">Southbound</option>
              </select>
              <select
                className="w-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setEquipmentType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Equipment Type
                </option>
                <option value="" disabled>
                  Select Equipment Type
                </option>
                <option value="">Any</option>
                <option value="DRY_VAN">Dry Van</option>
                <option value="FLATBED">Flatbed</option>
              </select>
              <div className="relative">
                <div
                  className="h-full flex justify-between items-center dark:bg-secondary-15 bg-white p-2 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 text-light-2 outline-none cursor-pointer"
                  onClick={originToggleDropdown}
                >
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {props.originMarket
                      ? props.originMarket
                      : props.originMarket == ""
                        ? "Any"
                        : "Select Origin Market"}
                  </span>
                  <ChevronDownIcon className="w-3 h-3" />
                </div>
                {isOpenOrigin && (
                  <div
                    className="w-full z-10 max-h-56 dark:bg-primary-1 bg-white text-light-2 dark:text-primary-10 text-xs border-2 dark:border-secondary-11 absolute left-0 top-10  items-start rounded-lg p-2 outline-none divide-y dark:divide-zinc-800  overflow-auto"
                    ref={origindropdownRef}
                  >
                    <div
                      className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap p-2 cursor-default text-primary-20"
                      aria-disabled
                    >
                      Select Origin Market
                    </div>
                    <div
                      className={
                        (props.originMarket == ""
                          ? "dark:bg-white/5 text-primary-11"
                          : "dark:text-primary-10") +
                        " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                      }
                      onClick={() => props.setOriginMarket?.("")}
                    >
                      Any
                    </div>
                    {props.originMarketList?.map((e, i) => (
                      <div
                        key={i}
                        className={
                          (props.originMarket == e
                            ? "dark:bg-white/5 text-primary-11"
                            : "dark:text-primary-10") +
                          " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                        }
                        onClick={() => props.setOriginMarket?.(e)}
                      >
                        {e}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="relative">
                <div
                  className="h-full flex justify-between items-center dark:bg-secondary-15 text-light-2 bg-white p-2 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none cursor-pointer"
                  onClick={destinationToggleDropdown}
                >
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {props.destinationMarket
                      ? props.destinationMarket
                      : props.destinationMarket == ""
                        ? "Any"
                        : "Select Destination Market"}
                  </span>

                  <ChevronDownIcon className="w-3 h-3" />
                </div>
                {isOpenDestination && (
                  <div
                    className="w-full z-10 max-h-56 dark:bg-primary-1 text-light-2 bg-white dark:text-primary-10 text-xs border-2 dark:border-secondary-11 absolute left-0 top-10  items-start rounded-lg p-2 outline-none divide-y dark:divide-zinc-800  overflow-auto"
                    ref={destinationdropdownRef}
                  >
                    <div
                      className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap p-2 cursor-default text-primary-20"
                      aria-disabled
                    >
                      Select Destination Market
                    </div>
                    <div
                      className={
                        (props.destinationMarket == ""
                          ? "dark:bg-white/5 text-primary-11"
                          : "dark:text-primary-10") +
                        " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                      }
                      onClick={() => props.setDestinationMarket?.("")}
                    >
                      Any
                    </div>
                    {props.destinationMarketList?.map((e, i) => (
                      <div
                        key={i}
                        className={
                          (props.destinationMarket == e
                            ? "dark:bg-white/5 text-primary-11"
                            : "dark:text-primary-10") +
                          " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                        }
                        onClick={() => props.setDestinationMarket?.(e)}
                      >
                        {e}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="lg:hidden block"></div>
              <div className="lg:hidden block"></div>
              <select
                className="w-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) =>
                  props.setActive?.(
                    e.target.value == "true"
                      ? true
                      : e.target.value == ""
                        ? undefined
                        : false,
                  )
                }
              >
                <option value="" hidden>
                  Select Active
                </option>
                <option value="" disabled>
                  Select Active
                </option>
                <option value="">Any</option>
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </div>
          )}
          {props.users && (
            <select
              className="h-full w-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
              onChange={(e) => props.setRole?.(e.target.value)}
            >
              <option value="" hidden>
                Select Role
              </option>
              <option value="" disabled>
                Select Role
              </option>
              <option value="">Any</option>
              <option value="ADMIN">ADMIN</option>
              <option value="SALESREP">SALESREP</option>
              <option value="CUSTOMER">CUSTOMER</option>
            </select>
          )}
          {props.marginPercentage && (
            <div className="grid grid-cols-3 gap-2 h-full">
              <div
                className="flex gap-1 items-center border-2 dark:text-primary-10 text-light-2 text-xs bg-white dark:border-secondary-11 dark:bg-secondary-15 rounded-md px-3 py-1 cursor-pointer h-full w-full whitespace-nowrap"
                onClick={() =>
                  props.handleGenerateCSV?.({
                    csv: true,
                    filters: props.filters,
                  })
                }
              >
                <ArrowDownTrayIcon className="w-4 h-4 dark:text-primary-3 " />
                <span>Download</span>
              </div>
              <div className="h-full w-full">
                <label
                  htmlFor="fileInput"
                  className="flex gap-1 items-center border-2 dark:text-primary-10 bg-white text-xs text-light-2 dark:border-secondary-11 rounded-md px-3 py-1 dark:bg-secondary-15 cursor-pointer h-full whitespace-nowrap"
                >
                  <ArrowUpTrayIcon className="w-4 h-4 dark:text-primary-3 cursor-pointer" />
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {fileName ? fileName : "Choose .xlsx or .xls file"}
                  </span>
                </label>
                <input
                  className="hidden"
                  id="fileInput"
                  type="file"
                  accept=".xlsx, .xls"
                  key={inputKey}
                  onChange={handleFileUpload}
                />
              </div>
              <select
                className="lg:w-44 w-full h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setEquipmentType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Equipment Type
                </option>
                <option value="" disabled>
                  Select Equipment Type
                </option>
                <option value="">Any</option>
                <option value="VAN">Van</option>
                <option value="FLATBED">Flatbed</option>
                <option value="REEFER">Reefer</option>
              </select>
            </div>
          )}
          {props.capacityType && (
            <div className="grid grid-cols-2 gap-2 h-full">
              <select
                className="h-full dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setEquipmentType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Equipment Type
                </option>
                <option value="" disabled>
                  Select Equipment Type
                </option>
                <option value="">Any</option>
                <option value="VAN">Van</option>
                <option value="FLATBED">Flatbed</option>
                <option value="REEFER">Reefer</option>
              </select>
              <div className="md:w-52 w-full relative">
                <div
                  className="h-full flex justify-between items-center dark:bg-secondary-15 bg-white p-2 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 text-light-2 outline-none cursor-pointer"
                  onClick={domestictoggleDropdown}
                >
                  <span>
                    {props.capacityTypeName
                      ? props.capacityTypeName
                      : props.capacityTypeName == ""
                        ? "Any"
                        : "Select Capacity Type"}
                  </span>
                  <ChevronDownIcon className="w-3 h-3" />
                </div>
                {isOpenDomestic && (
                  <div
                    className="w-full z-10 max-h-56 dark:bg-primary-1 bg-white dark:text-primary-10 text-light-2 text-xs border-2 dark:border-secondary-11 absolute left-0 top-10  items-start rounded-lg p-2 outline-none divide-y dark:divide-zinc-800  overflow-auto"
                    ref={domesticdropdownRef}
                  >
                    <div
                      className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap p-2 cursor-default dark:text-primary-20 text-light-2"
                      aria-disabled
                    >
                      Select Capacity Type
                    </div>
                    <div
                      className={
                        (props.capacityTypeName == ""
                          ? "dark:bg-white/5 text-primary-11"
                          : "dark:text-primary-10 text-light-2") +
                        " p-2 cursor-default hover:bg-white/5 dark:text-primary-10 text-light-2"
                      }
                      onClick={() => props.setCapacityType?.("")}
                    >
                      Any
                    </div>
                    {props.capacityTypeList?.map((e, i) => (
                      <div
                        key={i}
                        className={
                          (props.capacityTypeName == e
                            ? "dark:bg-white/5 text-primary-11"
                            : "dark:text-primary-10") +
                          " p-2 cursor-default hover:bg-white/5 dark:text-primary-10 whitespace-nowrap"
                        }
                        onClick={() => props.setCapacityType?.(e)}
                      >
                        {e}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
          {props.customerContractRates && (
            <div className="grid lg:grid-cols-3 grid-cols-2 gap-2 h-full">
              <select
                className="dark:bg-secondary-15 bg-white text-light-2 p-1 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setEquipmentType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Equipment Type
                </option>
                <option value="" disabled>
                  Select Equipment Type
                </option>
                <option value="">Any</option>
                <option value="DRY_VAN">Dry Van</option>
                <option value="FLATBED">Flatbed</option>
                <option value="REEFER">Reefer</option>
                <option value="STRAIGHT_TRUCK">Straight Truck</option>
                <option value="SPRINTER">Sprinter</option>
              </select>
              <div className="relative">
                <div
                  className="h-full flex justify-between items-center text-light-2 dark:bg-secondary-15 bg-white p-2 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none cursor-pointer"
                  onClick={originToggleDropdown}
                >
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {props.contractOrigin
                      ? props.contractOrigin
                      : props.contractOrigin == ""
                        ? "Any"
                        : "Select Contract Origin"}
                  </span>
                  <ChevronDownIcon className="w-3 h-3" />
                </div>
                {isOpenOrigin && (
                  <div
                    className="w-full z-10 max-h-56 dark:bg-primary-1 bg-white dark:text-primary-10 text-xs border-2 dark:border-secondary-11 absolute left-0 top-10  items-start rounded-lg p-2 outline-none divide-y dark:divide-zinc-800  overflow-auto"
                    ref={origindropdownRef}
                  >
                    <div
                      className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap p-2 cursor-default dark:text-primary-20 text-light-2 "
                      aria-disabled
                    >
                      Select Contract Origin
                    </div>
                    <div
                      className={
                        (props.contractOrigin == ""
                          ? "dark:bg-white/5 text-primary-11"
                          : "dark:text-primary-10 text-light-2") +
                        " p-2 cursor-default hover:bg-white/5 dark:text-primary-10 text-light-2"
                      }
                      onClick={() => props.setContractOrigin?.("")}
                    >
                      Any
                    </div>
                    {props.contractOriginList?.map((e, i) => (
                      <div
                        key={i}
                        className={
                          (props.contractOrigin == e
                            ? "dark:bg-white/5 text-primary-11"
                            : "dark:text-primary-10") +
                          " p-2 cursor-default hover:bg-white/5 dark:text-primary-10 text-light-2"
                        }
                        onClick={() => props.setContractOrigin?.(e)}
                      >
                        {e}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="lg:hidden block"></div>
              <div className="relative">
                <div
                  className="h-full flex justify-between items-center text-light-2 dark:bg-secondary-15 bg-white p-2 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none cursor-pointer"
                  onClick={destinationToggleDropdown}
                >
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {props.contractDestination
                      ? props.contractDestination
                      : props.contractDestination == ""
                        ? "Any"
                        : "Select Contract Destination"}
                  </span>
                  <ChevronDownIcon className="w-3 h-3" />
                </div>
                {isOpenDestination && (
                  <div
                    className="w-full z-10 max-h-56 dark:bg-primary-1 text-light-2 bg-white dark:text-primary-10 text-xs border-2 dark:border-secondary-11 absolute left-0 top-10  items-start rounded-lg p-2 outline-none divide-y dark:divide-zinc-800  overflow-auto"
                    ref={destinationdropdownRef}
                  >
                    <div
                      className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap p-2 cursor-default text-primary-20"
                      aria-disabled
                    >
                      Select Contract Destination
                    </div>
                    <div
                      className={
                        (props.contractDestination == ""
                          ? "dark:bg-white/5 text-primary-11"
                          : "dark:text-primary-10 ") +
                        " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                      }
                      onClick={() => props.setContractDestination?.("")}
                    >
                      Any
                    </div>
                    {props.contractDestinationList?.map((e, i) => (
                      <div
                        key={i}
                        className={
                          (props.contractDestination == e
                            ? "dark:bg-white/5 text-primary-11"
                            : "dark:text-primary-10") +
                          " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                        }
                        onClick={() => props.setContractDestination?.(e)}
                      >
                        {e}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
          {props.smallTruckRates && (
            <div className="grid md:grid-cols-4 grid-cols-2 gap-2 h-full">
              <div
                className="flex gap-1 items-center border-2 dark:text-primary-10 text-light-2 bg-white text-xs dark:border-secondary-11 rounded-md px-3 py-1 dark:bg-secondary-15 cursor-pointer h-full w-auto whitespace-nowrap"
                onClick={() =>
                  props.handleGenerateCSV?.({
                    csv: true,
                    filters: props.filters,
                  })
                }
              >
                <ArrowDownTrayIcon className="w-4 h-4 dark:text-primary-3 " />
                <span>Download</span>
              </div>
              <div>
                <label
                  htmlFor="fileInput"
                  className="flex gap-1 items-center border-2 dark:text-primary-10 text-light-2 bg-white text-xs dark:border-secondary-11 rounded-md px-3 py-1 dark:bg-secondary-15 cursor-pointer h-full w-auto whitespace-nowrap"
                >
                  <ArrowUpTrayIcon className="w-4 h-4 dark:text-primary-3 cursor-pointer" />
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {fileName ? fileName : "Choose .xlsx or .xls file"}
                  </span>
                </label>
                <input
                  className="hidden"
                  id="fileInput"
                  type="file"
                  accept=".xlsx, .xls"
                  key={inputKey}
                  onChange={handleFileUpload}
                />
              </div>
              <select
                className="lg:w-44 w-full dark:bg-secondary-15 bg-white p-1 text-xs border-2 text-light-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none"
                onChange={(e) => props.setEquipmentType?.(e.target.value)}
              >
                <option value="" hidden>
                  Select Equipment Type
                </option>
                <option value="" disabled>
                  Select Equipment Type
                </option>
                <option value="">Any</option>
                <option value="STRAIGHT_TRUCK">Straight Truck</option>
                <option value="SPRINTER_VAN">Sprinter Van</option>
              </select>
              <div className="relative">
                <div
                  className="h-full flex justify-between items-center dark:bg-secondary-15 bg-white text-light-2 p-2 text-xs border-2 dark:border-secondary-11 rounded-md dark:text-primary-10 outline-none cursor-pointer"
                  onClick={domestictoggleDropdown}
                >
                  <span className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap">
                    {props.groupName
                      ? props.groupName
                      : props.groupName == ""
                        ? "Any"
                        : "Select Group Name"}
                  </span>
                  <ChevronDownIcon className="w-3 h-3" />
                </div>
                {isOpenDomestic && (
                  <div
                    className="w-full z-10 max-h-56 dark:bg-primary-1 text-light-2 bg-white dark:text-primary-10 text-xs border-2 dark:border-secondary-11 absolute left-0 top-10  items-start rounded-lg p-2 outline-none divide-y dark:divide-zinc-800  overflow-auto"
                    ref={domesticdropdownRef}
                  >
                    <div
                      className="truncate xl:w-full lg:w-24 w-full whitespace-nowrap p-2 cursor-default dark:text-primary-20 text-light-2"
                      aria-disabled
                    >
                      Select Group Name
                    </div>
                    <div
                      className={
                        (props.groupName == ""
                          ? "dark:bg-white/5 text-primary-11"
                          : "dark:text-primary-10") +
                        " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                      }
                      onClick={() => props.setGroupName?.("")}
                    >
                      Any
                    </div>
                    {props.groupNameList?.map((e, i) => (
                      <div
                        key={i}
                        className={
                          (props.groupName == e
                            ? "dark:bg-white/5 text-primary-11"
                            : "dark:text-primary-10") +
                          " p-2 cursor-default hover:bg-white/5 dark:text-primary-10"
                        }
                        onClick={() => props.setGroupName?.(e)}
                      >
                        {e}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div
          className={
            (props.customerContractRates
              ? "lg:flex-row flex flex-col"
              : props.holidayModifer || props.transloadPartner || props.users
                ? "md:flex-row flex flex-col"
                : "xl:flex-row flex flex-col") + "  gap-2"
          }
        >
          <div
            className={
              props.capacityType ||
                props.marginPercentage ||
                props.directRates ||
                props.sportRates ||
                props.smallTruckRates
                ? "hidden"
                : ""
            }
          >
            {props.searchBar == true && (
              <div className="lg:py-0 py-2 dark:bg-transparent bg-white w-full px-2 h-10 flex justify-between items-center gap-1 border-2 dark:border-secondary-11 rounded-md">
                <input
                  className="dark:bg-transparent bg-white placeholder:text-xs placeholder-primary-16 placeholder:text-primary-20 dark:text-primary-10 text-light-2 outline-none w-full"
                  onChange={(e) => props.search && props.search(e.target.value)}
                  type="text"
                  placeholder="Search"
                  value={props.input}
                />
                <MagnifyingGlassIcon className="w-5 h-5 text-primary-10 cursor-pointer" />
              </div>
            )}
          </div>
          {props.btn != "" && (
            <button
              className={
                (props.marginPercentage ? "h-10" : "xl:h-10 h-9") +
                " md:text-md text-sm md:px-5 px-3 rounded-sm bg-primary-11 dark:text-secondary-1 text-white font-semibold"
              }
              onClick={props.btnClick}
            >
              {props.btn}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

Tab.defaultProps = {
  btn: "",
  barsIcon: false,
  paginationBtns: false,
  searchBar: false,
  maxPage: 1,
  btnClick: () => "",
}
